export { default } from "./ShoppingCartItem";
